!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.dayjs_plugin_compareTo = t()
}(this, function () {
  "use strict";
  return function (e, t) {
    t.prototype.compareTo = function (to) {
      if (this && !to) {
        return -1;
      } else if (to && !this) {
        return 1;
      } else if (this && to) {
        if (this.isBefore(to)) {
          return -1;
        } else if (this.isAfter(to)) {
          return 1;
        } else {
          return 0;
        }
      }
    }
  }
});
